import type {
  SearchCriteriaFilterSchema,
  SearchSearchCriteriaSchema,
} from '@iconik-io/iconik-api/src/services/search';

const traverseFilters = (
  filters: SearchCriteriaFilterSchema[] = [],
): SearchCriteriaFilterSchema[] => {
  let result: SearchCriteriaFilterSchema[] = [];
  for (const filter of filters) {
    if (
      filter.filters &&
      filter.operator !== 'OR' &&
      filter.operator !== 'NOT'
    ) {
      result = result.concat(traverseFilters(filter.filters));
    } else {
      result.push(filter);
    }
  }
  return result;
};

export const flattenSearchCriteriaFilters = (
  criteria: SearchSearchCriteriaSchema,
): SearchSearchCriteriaSchema => {
  const resultFilter: SearchCriteriaFilterSchema = {
    operator: 'AND',
    filters: traverseFilters(criteria.filter?.filters),
    terms: criteria.filter?.terms,
  };
  return {
    ...criteria,
    filter: resultFilter,
  };
};
